module.exports = __webpack_public_path__ + "media/images/webpage/shared/blank-01b832e09d5eb62c3b4a9a38806c0f58.webp";